var cov_14zymy2cne = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tag/index.ts",
      hash = "b20e0ce898f1db34497a4348973084f708e86ca7",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tag/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 21
        },
        end: {
          line: 4,
          column: 24
        }
      },
      "1": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 21
        }
      },
      "2": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 7,
          column: 34
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import Tag from './Tag';
import Input from './Input';
var Exports = (cov_14zymy2cne.s[0]++, Tag);
cov_14zymy2cne.s[1]++;
Exports.Input = Input;
cov_14zymy2cne.s[2]++;
Exports.displayName = 'ShinoutTag';
export default Exports;